// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import axios from 'axios'
import alertify from 'alertifyjs/build/alertify.min.js'
import 'alertifyjs/build/css/alertify.min.css'
import 'alertifyjs/build/css/themes/default.min.css'
import '@babel/polyfill'

window.alertify = alertify

Vue.config.productionTip = false

alertify.set('notifier', 'delay', 5)
alertify.set('notifier', 'position', 'top-center')
alertify.set('prompt', 'reverseButtons', true)
alertify.set('prompt', 'transition', 'fade')
alertify.set('confirm', 'transition', 'fade')

Vue.prototype.$axios = axios.create({
  headers: {
    'Content-Type': 'application/json',
    'Authorization': store.state.jwt
  },
  baseURL: store.state.apiEndpoint
})

Vue.prototype.$axios.interceptors.request.use(
  async config => {
    const token = store.state.jwt
    if (token) {
      config.headers['Authorization'] = token
    }
    if (!store.getters.isUserLoggedOut) {
      if (store.getters.isTokenExpired) {
        let found = store.state.notAuthUrls.find(function (element) {
          return element === config.url
        })
        if (!found) {
          store.dispatch('refreshToken').then((response) => {
            return Vue.nextTick(function () {
              config.headers.Authorization = response.headers.authorization
              return Vue.prototype.$axios(config)
            })
          })
        }
      }
    }
    return config
  },
  error => Promise.reject(error)
)

Vue.prototype.$axios.interceptors.response.use(
  response => response,
  error => {
    if (error && error.response && error.response.status && error.response.status === 401) {
      store.commit('removeJWT')

      // Avoid showing any errors
      return Promise.resolve()
    } else {
      console.log(error)
      // logger.error({
      //   message: 'Error in HTTP request',
      //   response: JSON.stringify(extractError(error)),
      //   status: _get(error, 'response.status', 'unknown'),
      //   url: _get(error, 'config.url', 'unknown'),
      //   userId: store.getters.userInfo.id
      // })
      return Promise.reject(error)
    }
  }
)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})

// var elem = document.querySelector('.grid')
// new Masonry(elem, {
//   itemSelector: '.grid .card',
//   columnWidth: 200,
//   horizontalOrder: true
// })



// WEBPACK FOOTER //
// ./src/main.js